"use client";

import type { ChartData, FinancialSnapshotNarrative } from "@/lib/types/financial-snapshot";
import { ChartCard } from "../ChartCard";
import { NarrativeBlock } from "../NarrativeBlock";
import { RevenueIncomeChart } from "../charts/RevenueIncomeChart";
import { MarginsChart } from "../charts/MarginsChart";
import { QuarterlyRevenueChart } from "../charts/QuarterlyRevenueChart";
import { CashFlowChart } from "../charts/CashFlowChart";

interface Props {
  data: ChartData;
  narrative: FinancialSnapshotNarrative | null;
}

export function OverviewTab({ data, narrative }: Props) {
  return (
    <div className="space-y-5">
      {narrative && <NarrativeBlock text={narrative.simpleEnglish} />}

      <ChartCard title="Revenue & Net Income" caption={narrative?.insights.revenueIncome}>
        <RevenueIncomeChart rows={data.revenueIncome} />
      </ChartCard>

      <ChartCard title="Margins" caption={narrative?.insights.margins}>
        <MarginsChart rows={data.margins} />
      </ChartCard>

      <ChartCard title="Quarterly Revenue" caption={narrative?.insights.quarterly}>
        <QuarterlyRevenueChart rows={data.quarterlyRevenue} />
      </ChartCard>

      <ChartCard title="Cash Flow" caption={narrative?.insights.cashFlow}>
        <CashFlowChart rows={data.cashFlow} />
      </ChartCard>
    </div>
  );
}
